// Every top bar in the app is one height.
export const TOP_BAR_HEIGHT = "h-12 max-h-12 min-h-12"

// Top bars share the sidebar header's inset so a content bar and the nav header
// beside it read as one band: 17.5px to the leading label (the nav's pl-2.5 plus
// its row's own 7.5px), 12px to the trailing actions. Bars that need a
// breakpoint variant spell out `sm:pl-[17.5px]` so Tailwind still sees the class.
export const TOP_BAR_PADDING = "pl-[17.5px] pr-3"

// The hidden sidebar's toggle floats over the card's top-left corner, so only the
// leftmost bar on a page moves its leading content past it. Zero while docked.
export const NAV_TOGGLE_CLEARANCE = "ml-[var(--nav-toggle-inset,0px)]"
export const TOP_BAR_PADDING_CLEARING_NAV_TOGGLE =
	"pl-[calc(17.5px+var(--nav-toggle-inset,0px))] pr-3"
